import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { StatisticsWidget5 } from '../../../_metronic/partials/widgets'
import { KTIcon } from '../../../_metronic/helpers'
import { useAuth } from '../../modules/auth'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ActivityLogWidget } from './ActivityLogWidget'
import { NEW_DASHBOARD_CARDS } from './dashboardNewCardsConfig'
import {
  useTotalProductsQuery,
  useTotalPriceMappingFeedQuery,
  useLastProductQuery,
  useScraperAccountStatusQuery,
  useTotalBuyersQuery,
  useTotalAdminsQuery,
  useNewCardQueries,
} from './useDashboardQueries'

const API_URL = process.env.REACT_APP_KT_API_URL || ''

// Formats a date as "18 August 2026, 6:18 PM" in the user's time zone
const formatCardDateTime = (value: string | Date | null | undefined): string => {
  if (!value) return '';
  const dateObj = new Date(value);
  if (isNaN(dateObj.getTime())) return '';
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit', month: 'long', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
    timeZone: userTimeZone,
  };
  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(dateObj);
  const dateParts: Record<string, string> = {};
  parts.forEach(p => {
    if (p.type !== 'literal') dateParts[p.type] = p.value;
  });
  return `${dateParts.day} ${dateParts.month} ${dateParts.year}, ${dateParts.hour}:${dateParts.minute} ${dateParts.dayPeriod}`;
}

const DashboardPage = ({
  user_type_id,
  isBuyerView,
  totalProductsQuery,
  priceMappingFeedQuery,
  totalBuyersQuery,
  totalAdminsQuery,
  lastProductQuery,
  scraperAccountStatusQuery,
  newCardQueries
}: any) => {
  const isBuyer = isBuyerView || user_type_id === 3;

  const totalProductsSuccess = totalProductsQuery.isSuccess;
  const priceMappingFeedSuccess = priceMappingFeedQuery.isSuccess;
  const totalBuyersSuccess = totalBuyersQuery.isSuccess;
  const totalAdminsSuccess = totalAdminsQuery.isSuccess;
  const checkIBSproduct = lastProductQuery.isSuccess;

  const total_productsLength = totalProductsQuery.data?.data?.meta?.totalItems;
  const newProductsCount = totalProductsQuery.data?.data?.meta?.newProductsCount;
  const usedProductsCount = totalProductsQuery.data?.data?.meta?.usedProductsCount;
  
  const total_price_mapping_feedLength = priceMappingFeedQuery.data?.data?.meta?.totalItems;
  const table_buyersLength = totalBuyersQuery.data?.data?.meta?.totalItems;
  const total_adminsLength = totalAdminsQuery.data?.data?.meta?.totalItems;

  const updateddate = formatCardDateTime(lastProductQuery.data?.data?.last_ibs_sync);
  const currentdate = formatCardDateTime(new Date());
  const lastScrapedDate = formatCardDateTime(scraperAccountStatusQuery.data?.data?.last_scrape_completed_at);
  const scraperStatus: string = scraperAccountStatusQuery.data?.data?.status || '';
  const scraperStatusColor = scraperStatus === 'active' ? 'success' : scraperStatus === 'suspended' ? 'danger' : 'warning';

  const lastScrapedCard = (
    <div className='col-xl-3'>
      <StatisticsWidget5
        className='card-xl-stretch h-100 mb-5 no-pointer'
        svgIcon='calendar-2'
        customIcon={
          <span className='position-relative d-inline-block'>
            <KTIcon iconName='calendar-2' className='text-primary fs-3x ms-n1' />
            <i
              className='fas fa-clock text-primary bg-body rounded-circle position-absolute'
              style={{fontSize: 14, bottom: -2, right: -4, padding: 1}}
            />
          </span>
        }
        color='light-white'
        iconColor='primary'
        title={lastScrapedDate}
        description='Last Scraped Update'
        titleColor='gray-900'
        descriptionColor='gray-500'
        skeltonLoader={scraperAccountStatusQuery.isSuccess}
        extra={scraperStatus ? (
          <div className='d-flex align-items-center gap-2 mt-2 fw-semibold text-gray-500 fs-7'>
            <span>Brightdata Account Status :</span>
            <span className={`badge badge-light-${scraperStatusColor} fs-7 fw-bold text-capitalize`}>
              {scraperStatus}
            </span>
          </div>
        ) : undefined}
      />
    </div>
  );

  return (
    <>
      <div className='row g-5 g-xl-8'>
        <Link to={"total-products"} className={'col-xl-3'} style={{cursor: !totalProductsSuccess ? "not-allowed" : "pointer", pointerEvents: !totalProductsSuccess ? "none" : "auto" }}>
          <StatisticsWidget5
            className='card-xl-stretch h-100'
            svgIcon='basket'
            color='body-white'
            iconColor='primary'
            title={total_productsLength === undefined ? "0" : total_productsLength?.toString()}
            description='Total Products'
            titleColor='gray-900'
            descriptionColor='gray-500'
            skeltonLoader={totalProductsSuccess}
            extra={isBuyer ? (
              <div className='d-flex gap-4 mt-2 fw-semibold text-gray-500 fs-7'>
                <span>New Products: <span className='text-gray-800 fw-bold'>{newProductsCount === undefined ? '0' : newProductsCount}</span></span>
                <span>Used Products: <span className='text-gray-800 fw-bold'>{usedProductsCount === undefined ? '0' : usedProductsCount}</span></span>
              </div>
            ) : undefined}
          />
        </Link>

        {isBuyer && (
          <React.Fragment>
            {NEW_DASHBOARD_CARDS.map((card, index) => {
              const query = newCardQueries[index];
              const isSuccess = query.isSuccess;
              const count = query.data?.data?.meta?.totalItems;
              return (
                <Link
                  key={card.key}
                  to={card.route}
                  className='col-xl-3'
                  style={{cursor: !isSuccess ? 'not-allowed' : 'pointer', pointerEvents: !isSuccess ? 'none' : 'auto'}}
                >
                  <StatisticsWidget5
                    className='card-xl-stretch h-100'
                    svgIcon={card.svgIcon}
                    faIcon={card.faIcon}
                    color='body-white'
                    iconColor={card.iconColor}
                    title={count === undefined ? '0' : count?.toString()}
                    description={card.label}
                    titleColor='gray-900'
                    descriptionColor='gray-500'
                    skeltonLoader={isSuccess}
                  />
                </Link>
              );
            })}
          </React.Fragment>
        )}

        {!isBuyer && (
          <React.Fragment>
            {/* First row */}
            <Link to={"total-admins"} className='col-xl-3' style={{cursor: !totalAdminsSuccess ? "not-allowed" : "pointer", pointerEvents: !totalAdminsSuccess ? "none" : "auto" }}>
              <StatisticsWidget5
                className='card-xl-stretch h-100 mb-5'
                svgIcon='element-11'
                color='body-white'
                iconColor='primary'
                title={total_adminsLength === undefined ? "0" : total_adminsLength?.toString()}
                description='Total Admins'
                titleColor='gray-900'
                descriptionColor='gray-500'
                skeltonLoader={totalAdminsSuccess}
              />
            </Link>
            <Link to={"total-buyers"} className='col-xl-3' style={{cursor: !totalBuyersSuccess ? "not-allowed" : "pointer", pointerEvents: !totalBuyersSuccess ? "none" : "auto" }}>
              <StatisticsWidget5
                className='card-xl-stretch h-100 mb-5'
                svgIcon='basket-ok'
                color='body-white'
                iconColor='warning'
                title={table_buyersLength === undefined ? "0" : table_buyersLength?.toString()}
                description='Total Buyers'
                titleColor='gray-900'
                descriptionColor='gray-500'
                skeltonLoader={totalBuyersSuccess}
              />
            </Link>
            {/* Second row */}
            {NEW_DASHBOARD_CARDS.map((card, index) => {
              if (!card.showForAdmin) return null;
              const query = newCardQueries[index];
              const isSuccess = query.isSuccess;
              const count = query.data?.data?.meta?.totalItems;
              return (
                <Link
                  key={card.key}
                  to={card.route}
                  className='col-xl-3'
                  style={{cursor: !isSuccess ? 'not-allowed' : 'pointer', pointerEvents: !isSuccess ? 'none' : 'auto'}}
                >
                  <StatisticsWidget5
                    className='card-xl-stretch h-100 mb-5'
                    svgIcon={card.svgIcon}
                    faIcon={card.faIcon}
                    color='body-white'
                    iconColor={card.iconColor}
                    title={count === undefined ? '0' : count?.toString()}
                    description={card.label}
                    titleColor='gray-900'
                    descriptionColor='gray-500'
                    skeltonLoader={isSuccess}
                  />
                </Link>
              );
            })}
            <div className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch h-100 mb-5 no-pointer'
                svgIcon='tag-cross'
                color='body-white'
                iconColor='primary'
                title={total_price_mapping_feedLength === undefined ? "0" : total_price_mapping_feedLength?.toString()}
                description="Total Products Price doesn't Feed"
                titleColor='gray-900'
                descriptionColor='gray-500'
                skeltonLoader={priceMappingFeedSuccess}
              />
            </div>
            {/* <div className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch h-100 mb-5 no-pointer'
                svgIcon='calendar-tick'
                color='body-white'
                iconColor='dark'
                title={currentdate}
                description='Last Currency Deviation Captured'
                titleColor='gray-900'
                descriptionColor='gray-500'
                skeltonLoader={true}
              />
            </div> */}
            <div className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch h-100 mb-5 no-pointer'
                svgIcon='calendar-tick'
                color='light-white'
                iconColor='info'
                title={updateddate}
                description='Last IBS Update'
                titleColor='gray-900'
                descriptionColor='gray-500'
                skeltonLoader={checkIBSproduct}
              />
            </div>
            {lastScrapedCard}
          </React.Fragment>
        )}
      </div>
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  const { currentUser, logout, auth } = useAuth()
  
  const tokenStr = auth?.access_token || ''
  const isBuyerView: boolean = useSelector((state: any) => state.buyerViewSwitch.isBuyerView)

  const totalProductsQuery = useTotalProductsQuery(API_URL, tokenStr, currentUser, logout, isBuyerView);
  const priceMappingFeedQuery = useTotalPriceMappingFeedQuery(API_URL, tokenStr, currentUser, logout, isBuyerView);
  const lastProductQuery = useLastProductQuery(API_URL, tokenStr, logout);
  const totalBuyersQuery = useTotalBuyersQuery(API_URL, tokenStr, currentUser, logout, isBuyerView);
  const totalAdminsQuery = useTotalAdminsQuery(API_URL, tokenStr, currentUser, logout, isBuyerView);
  const scraperAccountStatusQuery = useScraperAccountStatusQuery(API_URL, tokenStr, currentUser, logout, isBuyerView);
  const newCardQueries = useNewCardQueries(API_URL, tokenStr, currentUser, logout, isBuyerView);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage
        user_type_id={currentUser?.user_type?.id}
        isBuyerView={isBuyerView}
        totalProductsQuery={totalProductsQuery}
        priceMappingFeedQuery={priceMappingFeedQuery}
        totalBuyersQuery={totalBuyersQuery}
        totalAdminsQuery={totalAdminsQuery}
        lastProductQuery={lastProductQuery}
        scraperAccountStatusQuery={scraperAccountStatusQuery}
        newCardQueries={newCardQueries}
      />
      <ActivityLogWidget />
    </>
  )
}

export { DashboardWrapper }
